/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Pin_DescInputs */

const en_story_pin_desc = /** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep on your profile permanently`)
};

const es_story_pin_desc = /** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantener en tu perfil permanentemente`)
};

const fr_story_pin_desc = /** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserver sur votre profil en permanence`)
};

const de_story_pin_desc = /** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauerhaft auf deinem Profil behalten`)
};

const id_story_pin_desc = /** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan di profil Anda secara permanen`)
};

/** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */
const ja_story_pin_desc = en_story_pin_desc;

/** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */
const zh_story_pin_desc = en_story_pin_desc;

/** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */
const ar_story_pin_desc = en_story_pin_desc;

/** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */
const it_story_pin_desc = en_story_pin_desc;

/** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */
const ru_story_pin_desc = en_story_pin_desc;

/** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */
const pt_story_pin_desc = en_story_pin_desc;

/** @type {(inputs: Story_Pin_DescInputs) => LocalizedString} */
const ko_story_pin_desc = en_story_pin_desc;

/**
* | output |
* | --- |
* | "Keep on your profile permanently" |
*
* @param {Story_Pin_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_pin_desc = /** @type {((inputs?: Story_Pin_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Pin_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_pin_desc(inputs)
	if (locale === "es") return es_story_pin_desc(inputs)
	if (locale === "fr") return fr_story_pin_desc(inputs)
	if (locale === "de") return de_story_pin_desc(inputs)
	if (locale === "ja") return ja_story_pin_desc(inputs)
	if (locale === "zh") return zh_story_pin_desc(inputs)
	if (locale === "ar") return ar_story_pin_desc(inputs)
	if (locale === "id") return id_story_pin_desc(inputs)
	if (locale === "it") return it_story_pin_desc(inputs)
	if (locale === "ru") return ru_story_pin_desc(inputs)
	if (locale === "pt") return pt_story_pin_desc(inputs)
	return ko_story_pin_desc(inputs)
});